// Plausible custom-event wrapper. No-op if the Plausible script never loads
// (e.g. blocked, or no domain configured at plausible.io).
//
//   import { track, pageview } from '@/lib/analytics'
//   track('cta_click', { location: 'hero' })

export function track(event, props) {
  if (typeof window === 'undefined') return
  if (typeof window.plausible !== 'function') {
    window.plausible = window.plausible || function () {
      ;(window.plausible.q = window.plausible.q || []).push(arguments)
    }
  }
  window.plausible(event, props ? { props } : undefined)
}

// Plausible is loaded in manual SPA mode — emit pageviews on route change.
export function pageview() {
  track('pageview')
}
